import React from "react";
import "./custom-css/isometric-button.css";

const IsometricButton = ({
                             label = "SCOPRI DI PIÙ",
                             textColor = "#f0f0f0",
                             backgroundColor = "#858585",
                             sideColor = "#151515",
                             bottomColor = "#333333",
                                scale = "scale(0.7)"
                         }) => {
    return (
        <div className="button-box" style={{ "--transform": scale }} >
            <button
                className="isometric-button"
                style={{
                    "--background-color": backgroundColor,
                    "--text-color": textColor,
                    "--side-color": sideColor,
                    "--bottom-color": bottomColor,
                }}
            >
                {label}
            </button>
        </div>
    );
};

export default IsometricButton;
